//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'
import { BTab, BTabs, VBPopover } from 'bootstrap-vue'

import Vue from 'vue'
Vue.directive('b-popover', VBPopover)

/*if(process.client) {
    window.Glider = require('glider-js')
}*/

//import {VueAgile} from "vue-agile"

export default {

  name: 'ProfileSpacesRooms',

  mixins: [ProfileData],

  components: { BTab, BTabs/*, agile: VueAgile*/ },

  props: {
    company: {
    },
    destination: {
    },
  },

  data() {
    return {
      rowLimit: 5,
      rowsShowedSpaces: 0,
      rowsShowedRooms: 0,

      agileOptions: {
        autoplay: false,
        dots: false,
        navButtons: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        /*responsive: [

          {
            breakpoint: 676,
            settings: {
              slidesToShow: 2,
            }
          },

          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
            }
          }
        ]*/
      }
    }
  },

  mounted() {

    this.rowsShowedSpaces = this.rowLimit
    this.rowsShowedRooms = this.rowLimit

    /*this.$nextTick(function () {

        const gliderEl = document.querySelector('.glider')

        if(gliderEl) {

            new Glider(gliderEl, {

                responsive: [
                    {
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 3,
                            // dots: '#dots',
                            draggable: true,
                            slidesToScroll: 2,
                            arrows: {
                                prev: '#glider-prev-space',
                                next: '#glider-next-space'
                            },
                        }
                    },
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            draggable: true,
                            arrows: {
                                prev: '#glider-prev-space',
                                next: '#glider-next-space'
                            },
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            draggable: true,
                            arrows: {
                                prev: '#glider-prev-space',
                                next: '#glider-next-space'
                            },
                        }
                    },

                ]

            })

        }


      const gliderRoomEl = document.querySelector('.glider-room')

      if(gliderRoomEl) {

        new Glider(gliderRoomEl, {

          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 6,
                // dots: '#dots',
                draggable: true,
                slidesToScroll: 6,
                arrows: {
                  prev: '#glider-prev-room',
                  next: '#glider-next-room'
                },
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 6,
                // dots: '#dots',
                draggable: true,
                slidesToScroll: 6,
                arrows: {
                  prev: '#glider-prev-room',
                  next: '#glider-next-room'
                },
              }
            },
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                draggable: true,
                arrows: {
                  prev: '#glider-prev-room',
                  next: '#glider-next-room'
                },
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                draggable: true,
                arrows: {
                  prev: '#glider-prev-room',
                  next: '#glider-next-room'
                },
              }
            },

          ]

        })

      }

    })*/


  },

  methods: {

    spaceImageDataContent(space) {
      return "<img src='"+space.mediaUrl+"' width='100%' alt='"+space.name+"' />";
    },

    loadMoreSpaces() {
      this.rowsShowedSpaces += this.rowLimit
    },

    hideSpaceRow(index) {

      if(index >= this.rowsShowedSpaces) {
        return true
      }

      return false
    },

    roomImageDataContent(room) {
      return "<img src='"+room.mediaUrl+"' width='100%' alt='"+room.name+"' />";

    },

    loadMoreRooms() {
      this.rowsShowedRooms += this.rowLimit
    },

    hideRoomRow(index) {

      if(index >= this.rowsShowedRooms) {
        return true
      }

      return false
    },

  },

  computed: {

    servicesSet() {
      return this.$helper.chunk(this.destination.servicesDisplayArr, 3)
    },

    showLoadMoreSpaces() {

      if(this.destination.hasSpaces === false) {
        return false
      }

      if(this.destination.spaces.length > this.rowsShowedSpaces) {
        return true
      }

      return false
    },

    showLoadMoreRooms() {

      if(this.destination.hasRooms === false) {
        return false
      }

      if(this.destination.rooms.length > this.rowsShowedRooms) {
        return true
      }

      return false
    },

  }

}

